import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import { addTech } from "../../../functions/technicians";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../../../components/toolkit/loader";

const AddTech = ({ arg: { setRefreshData } }) => {
  const [tech, setTech] = useState({
    name: "",
    techId: "",
    email: "",
    password: "",
    IsVerified: 1,
    netsuite_id: "",
    isDeleted: 0,
    role: "tech",
  });
  const [open, setOpen] = useState(false);
  const cookies = new Cookies();
  const token = cookies.get("token");
  const dispatch = useDispatch();
  const { loader } = useSelector((state) => ({ ...state }));

  const showModal = () => {
    setOpen(true);
  };
  const inputHandler = (e) => {
    setTech({ ...tech, [e.target.name]: e.target.value });
  };

  const handleOk = async (e) => {
    e.preventDefault();
    dispatch(loaderReducer(true));
    try {
      await addTech(token, tech)
        .then((res) => {
          // console.log(res);
          dispatch(loaderReducer(false));
          setRefreshData(res.data.user.email);
          setOpen(false);
          toast.success("Technician’s Account added successfully.");
          setTech({
            name: "",
            techId: "",
            email: "",
            password: "",
            IsVerified: 1,
            netsuite_id: "",
            isDeleted: 0,
            role: "tech",
          });
        })
        .catch((err) => {
          // console.log(err);
          // setOpen(false);
          dispatch(loaderReducer(false));
          err.response.status === 409
            ? toast.error("Email/TechId already exists.")
            : err.response.status === 400
            ? toast.error("Email and Password is required.")
            : err.response.status === 500
            ? toast.error(err.response.data.message)
            : toast.error("Please check the details and try again.");
        });
    } catch (error) {
      toast.error(error);
      dispatch(loaderReducer(false));
    }
    console.log(tech);
  };

  const handleCancel = () => {
    console.log("Clicked cancel button");
    setOpen(false);
  };

  console.log("loader", tech);

  const contentData = () => (
    <form className="need-validation">
      <div className="row mt-4">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Name</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            type="text"
            className="form-control"
            name="name"
            value={tech.name}
            onChange={(e) => inputHandler(e)}
            placeholder="*Name"
            required
            autoComplete="off"
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Tech ID</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            type="text"
            className="form-control"
            name="techId"
            value={tech.techId}
            onChange={(e) => inputHandler(e)}
            placeholder="*Tech ID"
            required
            autoComplete="off"
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Email</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            type="email"
            className="form-control"
            name="email"
            value={tech.email}
            onChange={(e) => inputHandler(e)}
            placeholder="*Email"
            required
            autoComplete="off"
          />
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">Password</div>
        <div className="col-lg-10 col-md-8 col-sm-12 position-relative">
          <input
            type="password"
            className="form-control"
            name="password"
            value={tech.password}
            onChange={(e) => inputHandler(e)}
            placeholder="*Password"
            required
          />
        </div>
      </div>
      <div className="d-flex gap-3 mt-3">
        <button onClick={handleCancel} className="cancelbtn">
          Cancel
        </button>
        <button
          type="submit"
          onClick={handleOk}
          className="addtechbtn"
          // disabled={!tech.name || !tech.email || !tech.password || !tech.techId}
        >
          Add Technician
        </button>
      </div>
    </form>
  );

  return (
    <>
      <div className="contd" onClick={showModal}>
        Add Technician’s Account
      </div>
      <Modal open={open} onOk={handleOk} onCancel={handleCancel} footer="">
        <p>{contentData()}</p>
      </Modal>
    </>
  );
};
export default AddTech;
